import DataNotFoundImage from "../../Assets/DataNotFound.png";

const NoDataFound = ({ message = 'No Data Found' }) => {
    return (
        <div className="flex flex-col items-center justify-center text-center space-y-4">

            <img
                src={DataNotFoundImage}
                alt="No Guests"
                className="w-40 h-40 object-cover opacity-80"
            />

            <h3 className="text-lg font-semibold text-gray-700 mt-0">
                {message}
            </h3>
        </div>
    )
}

export default NoDataFound